// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__24g1M","bigColWidth":"Table_bigColWidth__1c5l6","biggerColWidth":"Table_biggerColWidth__3akbY","row":"Table_row__PeY5O","col":"Table_col__3kg7W"};